// Карточка товара открывается из списка в новой вкладке — после сохранения даём знать остальным вкладкам
const CHANNEL_NAME = 'mison-products-changed'

export function notifyProductsChanged() {
	if (typeof BroadcastChannel === 'undefined') return
	try {
		const channel = new BroadcastChannel(CHANNEL_NAME)
		channel.postMessage({ at: Date.now() })
		channel.close()
	} catch (e) { /* без синхронизации вкладок список обновится вручную */ }
}

export function subscribeProductsChanged(callback) {
	if (typeof BroadcastChannel === 'undefined') return () => { }
	const channel = new BroadcastChannel(CHANNEL_NAME)
	channel.onmessage = () => callback()
	return () => channel.close()
}
